import { Observable } from "rxjs";
import { msgGen } from "../shared/errorMessages";
import { IFilter, ILoadOptions, IRemoteCollectionStoreOptions } from "../types";
import { AllowedKeyType, KeyDefinitionType } from "../types/key-types";

const remoteStoreMethodNotImplmeneted = (method: string) => msgGen.METHOD_NOT_IMPLEMENTED('RemoteCollectionStore.' + method);


export class RemoteCollectionStore<TModel extends { [key: string]: any }, TKeyType extends AllowedKeyType> implements IRemoteCollectionStoreOptions<TModel, TKeyType> {

  readonly keyField: KeyDefinitionType<TKeyType>;

  constructor(
    private _options: IRemoteCollectionStoreOptions<TModel, TKeyType>
  ) {

    this.keyField = this._options.keyField;
  }

  byKey(key: TKeyType): Observable<TModel> {
    if (!this._options.byKey) {
      throw { message: remoteStoreMethodNotImplmeneted('byKey') }
    }

    return this._options.byKey(key)
  }

  load(loadOptions?: ILoadOptions<TModel>): Observable<TModel[]> {

    if (!this._options.load) {
      throw { message: remoteStoreMethodNotImplmeneted('load') }
    }

    return this._options.load(loadOptions);
  }

  insert(insertJSON: Partial<TModel>) {
    if (!this._options.insert) {
      throw { message: remoteStoreMethodNotImplmeneted('insert') }
    }

    return this._options.insert(insertJSON);
  }

  update(key: TKeyType, updateJSON: Partial<TModel>) {
    if (!this._options.update) {
      throw { message: remoteStoreMethodNotImplmeneted('update') }
    }

    return this._options.update(key, updateJSON);
  }

  remove(key: TKeyType) {
    if (!this._options.remove) {
      throw { message: remoteStoreMethodNotImplmeneted('remove') }
    }

    return this._options.remove(key)
  }

  //todo advanced
  insertBatch(insertJSONArray: Partial<TModel>[]) {
    if (!this._options.insertBatch) {
      throw { message: remoteStoreMethodNotImplmeneted('insertBatch') }
    }

    return this._options.insertBatch(insertJSONArray);
  }

  removeBatch(keyArray: TKeyType[]) {
    if (!this._options.removeBatch) {
      throw { message: remoteStoreMethodNotImplmeneted('removeBatch') }
    }

    return this._options.removeBatch(keyArray);
  }

  updateBatch(updatePairs: { key: TKeyType, updateJSON: TModel }[]) {
    if (!this._options.updateBatch) {
      throw { message: remoteStoreMethodNotImplmeneted('updateBatch') }
    }

    return this._options.updateBatch(updatePairs);
  }

  reorderShallow(reorderPairs: { key: TKeyType, orderIdx: number }[]) {
    if (!this._options.reorderShallow) {
      throw { message: remoteStoreMethodNotImplmeneted('reorderShallow') }
    }

    return this._options.reorderShallow(reorderPairs);
  }

  //todo advanced
  reorderDeep(params: { fromKey: TKeyType, toKey: TKeyType, insertType: 'into' | 'after' | 'before' }) {

    if (!this._options.reorderDeep) {
      throw { message: remoteStoreMethodNotImplmeneted('reorderDeep') }
    }

    return this._options.reorderDeep(params);
  }

  remoteSelect(selectionFilter: IFilter[]) {

    if (!this._options.remoteSelect) {
      throw { message: remoteStoreMethodNotImplmeneted('remoteSelect') }
    }

    return this._options.remoteSelect(selectionFilter);
  }

}
